<script setup>
/* eslint-disable vue/no-bare-strings-in-template */
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const globalConfig = useMapGetter('globalConfig/get');
const displayVersion = computed(() => {
  const rawVersion = globalConfig.value?.appVersion || '';
  const trimmed = rawVersion
    .replace(/\s*\(.*\)\s*/g, '')
    .replace(/\s*Build\s+unknown\s*/i, '')
    .trim();
  return trimmed ? `Teasweb v${trimmed}` : 'Teasweb';
});
</script>

<template>
  <div class="p-4 text-sm text-center">
    <div class="divide-x divide-n-slate-9">
      <span class="px-2">{{ displayVersion }}</span>
    </div>
    <div class="mt-2 text-xs text-n-slate-11">
      This product includes software developed by Chatwoot and its contributors,
      licensed under the MIT License.
    </div>
  </div>
</template>
